module.exports = __webpack_public_path__ + "./images/c9a75fa1ca35f878b7d921f8699a56b9.webp";